import React, { useState, useEffect } from "react";
import { PencilSquare, Trash } from "react-bootstrap-icons";
import api from "../api/api";
import { toast } from "react-toastify";

const Categories = () => {
  const [categories, setCategories] = useState([]);  // Fetch Data State

  const [categoryName, setCategoryName] = useState("");    // Insert Data State
  const [editId, setEditId] = useState(null);           // Edit Data State

  const API_URL = "/Categories"; // Categories API Url

  // ===================== FETCH ALL =====================
  const fetchCategories = async () => {
    try {
      const res = await api.get(API_URL);
      setCategories(res.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // ===================== ADD / UPDATE =====================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!categoryName.trim()) {
    toast.warning("Category name is required ⚠️");
    return;
  }

    try {
      if (editId) {
        // UPDATE
        await api.put(`${API_URL}/${editId}`, {
          categoryName: categoryName,
        });
        toast.info("Category Updated Successfully ✏️");
        
      } else {
        // CREATE
        await api.post(API_URL, {
          categoryName: categoryName,
        });
        toast.success("Category Added Successfully ✅");
      }

      setCategoryName("");
      setEditId(null);
      fetchCategories();
    } catch (error) { 
      toast.error("Failed to save category ❌");
    }
  };

  // ===================== TABLE EDIT =====================
  const handleEdit = (category) => {
    setCategoryName(category.categoryName);
    setEditId(category.categoryId);
  };

  /* Delete  */
  // ===================== DELETE =====================
  const handleDelete = async (categoryId) => {
    if (window.confirm("Are you sure you want to delete?")) {
      try {
        await api.delete(`${API_URL}/${categoryId}`);
       toast.error("Category Deleted Successfully 🗑️");
        fetchCategories();
      } catch (error) {
       toast.error("Failed to Delete category ❌");
      }
    }
  };

  return (
    <div className="categories-page">

      <div className="page-header">
        <h5>Categories</h5>
      </div>

      {/* ===== Form Card ===== */}
      <div className="card p-4 mb-2">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-9">
              <label>Category Name</label>
              <input
                type="text"
                className="form-control"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                placeholder="Enter category name"
              />
            </div>

            <div className="col-md-3 d-flex align-items-end">
              <button type="submit" className="btn btn-primary me-2">
                {editId ? "Update Category" : "Add Category"}
              </button>

              {editId && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setEditId(null);
                    setCategoryName("");
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </form>
      </div>

      {/* ===== Table Card ===== */}
      <div className="card-box">
        <h6>Category List</h6>

        <div className="table-responsive">
          <table className="admin-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Category Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    No categories found
                  </td>
                </tr>
              ) : (
                categories.map((cat, index) => (
                  <tr key={cat.categoryId}>
                    <td>{index + 1}</td>
                    <td>{cat.categoryName}</td>
                    <td>
                      <button
                        className="btn-icon edit"
                        onClick={() => handleEdit(cat)}
                      >
                        <PencilSquare />
                      </button>

                      <button
                        className="btn-icon delete"
                        onClick={() => handleDelete(cat.categoryId)}
                      >
                        <Trash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>

    </div>
  );
};

export default Categories;